export default "__VITE_ASSET__mQiDv2Kv__"